<template>
  <div class="login-form-body">
    <div class="login-form-container">
      <van-form ref="loginForm" class="normal-grace-white-form" @submit="login">
        <PhoneInput v-show="!isSend" v-model="formData.phone" :rules="loginPhoneRule.phone" @areaChange="areaChange" />
        <CodeInput v-show="isSend" ref="phoneCode" v-model="formData.captcha" :scene="scene" type="phone" :phone="formData.phone" :rules="loginPhoneRule.captcha"
                   :area-code="formData.phoneAreaCode.value" :cookie-name="cookieName" :before-send="codeBeforeSend" :send-success="codeSendSuccess" :send-error="codeSendError"
        />
      </van-form>
      <!-- 可以切换 -->
      <div v-if="canSwitchType">
        <div v-if="!isSend" class="button-container">
          <van-button type="primary" class="button button-normal primary-button font-semibold" :text="$t('login.login.loginForm.continueBtn')" :disabled="!isPhoneContinue" :loading="sendLoading" @click="goSendCode('phoneCode')" />
          <div class="divider">
            <span class="divider-line left" />
            <span class="divider-text">or</span>
            <span class="divider-line right" />
          </div>
          <van-button class="button button-normal common-button font-semibold" :text="$t('login.login.loginForm.switchEmail')" :disabled="sendLoading" @click="switchType('email')" />
        </div>
        <div v-if="isSend" class="button-container">
          <van-button type="primary" class="button button-normal primary-button font-semibold" :text="$t('login.login.loginForm.submitBtnText')" :loading="isLoging" :disabled="!isLoginSubmitAvalible" @click="loginSubmit" />
        </div>
      </div>
      <!-- 不可以切换 -->
      <div v-else>
        <div v-show="!isSend" class="button-container">
          <div :class="['arrow-button', !isPhoneContinue ? 'arrow-disabled': '']" @click="goSendCode('phoneCode')">
            <div class="arrow-img" />
          </div>
        </div>
        <div v-show="isSend" class="button-container">
          <van-button type="primary" class="button button-normal dialog-button font-semibold" :text="$t('bindForm.submitBtn')" :loading="isLoging" :disabled="!isLoginSubmitAvalible" @click="loginSubmit" />
        </div>
        <div class="tip font-medium">
          {{ $t('bindForm.tip')+' '+contact }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PhoneInput from 'components/login/newLoginForm/phoneInput.vue';
import CodeInput from 'components/login/newLoginForm/codeInput.vue';
import { oneApi } from 'config/api';

export default {
  components: { PhoneInput, CodeInput },
  props: {
    isLoging: { // 登陆按钮加载中
      type: Boolean,
      default: false,
    },
    canSwitchType: {
      type: Boolean,
      default: true,
    },
    cookieName: {
      type: String,
      default: 'login-phone-count',
    },
    scene: {
      type: Number,
      default: 1,
    },
    execute: {
      type: Boolean,
      default: false,
    },
    guide: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isChecking: false, // 检测中
      contact: this.$t('common.contactPhone') !== '' ? this.$t('common.contactPhone') : this.$t('common.contactEmail'),
      isSend: false, // 是否切换到code页面
      sendLoading: false, // 按钮加载中状态
      formData: {
        phone: '',
        captcha: '',
        phoneAreaCode: {
          value: '',
        },
      },
      loginPhoneRule: {
        phone: [{
          required: true,
          message: this.$t('login.login.loginForm.phone.rules.required'),
          trigger: 'onBlur',
          formatter: (value) => value.trim(),
        }],
        captcha: [{
          required: true,
          message: this.$t('login.login.loginForm.captcha.rules.required'),
          trigger: 'onBlur',
          formatter: (value) => value.trim(),
        },
        {
          pattern: /^\d{6}$/,
          message: this.$t('login.login.loginForm.captcha.rules.format'),
          trigger: 'onBlur',
          formatter: (value) => value.trim(),
        }],
      },
    }
  },
  computed: {
    isLoginSubmitAvalible() {
      return /^\d{6}$/.test(this.formData.captcha);
    },
    isPhoneContinue() {
      if (this.formData.phoneAreaCode.reg) {
        return this.formData.phoneAreaCode.reg.test(this.formData.phone)
      }
      return this.formData.phone.trim() !== ''
    },
  },
  methods: {
    init() {
      this.$refs.phoneCode.init();
      this.formData.captcha = '';
      this.isSend = false
    },
    /**
     * 触发登录按钮
     */
    loginSubmit() {
      this.$refs.loginForm.submit();
    },
    login() {
      this.$emit('submit', this.formData)
    },
    // 切换表单
    switchType() {
      this.formData.phone = '';
      this.$refs.loginForm.resetValidation();
      this.$emit('switch')
    },
    areaChange(obj) {
      this.formData.phoneAreaCode = obj;
      this.setPhonePattern();
      if (this.formData.phone === '') return;
      this.$refs.loginForm.validate('phone');
    },
    // 触发发送验证码
    goSendCode(codInputName) {
      console.log('看看44')
      if (this.sendLoading || !this.isPhoneContinue) {
        return undefined
      }
      if (this.execute) {
        return this.guide(this.formData)
      }
      return this.$refs[codInputName].sendCodeHanlder()
    },
    // 设置手机号正则校验格式
    setPhonePattern() {
      const { reg } = this.formData.phoneAreaCode;
      this.loginPhoneRule.phone[1] = {
        pattern: reg,
        message: this.$t('login.login.loginForm.phone.rules.format'),
        trigger: 'onBlur',
        formatter: (value) => value.trim(),
      }
    },
    // 验证码发送前
    codeBeforeSend(callback) {
      console.log('校验手机号4')
      this.$refs.loginForm.validate('phone').then(async () => {
        this.sendLoading = true;
        // 绑定联系方式时需要验证联系方式是否重复
        if (this.scene === 3 && !this.isChecking) {
          const data = {
            type: 0,
            countryCallingCode: this.formData.phoneAreaCode.value,
            contactInfo: this.formData.phone,
          }
          this.isChecking = true
          console.log('校验手机号23');
          const res = await this.$axios.post(oneApi.contactVerify, data, { rewritePostBody: true })
          this.isChecking = false
          if (Number(res.code) !== 0) {
            this.$Toast(res.msg);
            this.sendLoading = false;
            return;
          }
        }
        callback();
      });
    },
    // 发送成功
    codeSendSuccess() {
      this.sendLoading = false;
      this.isSend = true;
      let valueCode = ''
      // 修改dialog文案使用
      valueCode = `+${this.formData.phoneAreaCode.value} ${this.formData.phone}`
      this.$emit('titleChange', {
        isSend: this.isSend,
        valueCode,
      })
    },
    codeSendError() {
      this.sendLoading = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.button-container {
  text-align: center;

  .van-button--primary {
    .van-loading__spinner--circular {
      color: var(--txt-color-link) !important;
    }
  }
}

.primary-button {
  width: px2vw(360);
  height: px2vw(96);
  background: #fff;
  border-radius: px2vw(48);
  font-size: px2vw(32);
  text-align: center;
  color: var(--txt-color-link);
  line-height: px2vw(96);
  padding: 0;
  margin-bottom: px2vw(16);

  &[disabled] {
    color: var(--txt-color-lv2);
    background: #f4f6fa;
  }
}

.common-button {
  width: px2vw(360);
  height: px2vw(96);
  border-radius: px2vw(48);
  border: px2vw(5) solid rgba(255, 255, 255, 0.8);
  font-size: px2vw(32);
  text-align: center;
  color: #fff;
  line-height: px2vw(96);
  padding: 0;
  background: transparent;

  &[disabled] {
    color: var(--txt-color-lv2);
    background: #f4f6fa;
  }
}

.dialog-button {
  width: px2vw(294);
  height: px2vw(96);
  text-align: center;
  background: var(--txt-color-link);
  border-radius: px2vw(48);
  color: #fff;
  padding: 0;
  font-size: px2vw(32);
  margin-bottom: px2vw(32);

  &[disabled] {
    color: var(--txt-color-lv2);
    background: #f4f6fa;
  }
}

.divider {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: px2vw(16);

  .divider-line {
    height: px2vw(2);
    width: px2vw(100);
    background-color: var(--txt-color-link3);
  }

  .left {
    margin-right: px2vw(14);
  }

  .right {
    margin-left: px2vw(14);
  }

  .divider-text {
    font-weight: 500;
    color: var(--txt-color-link3);
    font-size: px2vw(32);
  }
}

.arrow-button {
  width: px2vw(96);
  height: px2vw(96);
  background: var(--txt-color-link);
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto px2vw(32);
  cursor: pointer;

  &:hover {
    background: var(--txt-color-link2);
  }

  .arrow-img {
    background: url('~assets/images/common/next-arrow.png') no-repeat;
    background-size: 100%;
    width: px2vw(40);
    height: px2vw(40);
  }
}

.arrow-disabled {
  opacity: 0.2;
}

.tip {
  font-size: px2vw(24);
  color: var(--txt-color-lv2);
  line-height: px2vw(28);
  text-align: center;
  margin-bottom: px2vw(40);
}
</style>
